var _g, _path, _path2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_0_5507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.842 9.26318H10.7363C9.77027 9.26318 8.96317 9.99881 8.87385 10.9607C8.77202 12.0573 9.63496 13.0041 10.7363 13.0041H14.0817C15.705 13.0041 17.0209 14.32 17.0209 15.9433C17.0209 17.5667 15.705 18.8826 14.0817 18.8826H10.123C9.2531 18.8826 8.46995 19.4098 8.14254 20.2157C7.57149 21.6214 8.60578 23.1579 10.123 23.1579H15.842C18.6034 23.1579 20.842 20.9193 20.842 18.1579V14.2632C20.842 11.5018 18.6034 9.26318 15.842 9.26318Z",
    fill: "#2C9547"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4212 5.23414L12.158 5.21045L12.158 23.1578L10.4212 23.1578V5.23414Z",
    fill: "url(#paint0_linear_0_5507)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49097 0.00140618V22.8598H8.98194H10.882V5.50119C19.6912 4.81372 25.9094 7.21986 25.9094 16.6726C25.9094 24.2348 19.4609 26.2399 16.2366 26.2972H4.49097V24.7504L0 28.5314L4.49097 33V31.4532L17.1002 31.7969C21.6603 31.7969 26.0246 29.047 27.6367 27.6721C34.2696 21.7599 32.5883 12.605 30.9186 8.76665C27.8786 1.61696 19.9791 -0.055883 16.4093 0.00140618H4.49097Z",
    fill: "#F6D724"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8947,
    cy: 16.2105,
    r: 0.578947,
    fill: "#F6D724"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_0_5507",
    x: 4.98315,
    y: 8.26318,
    width: 18.8589,
    height: 19.8948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_5507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_5507",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_5507"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_5507",
    x1: 9.42867,
    y1: 19.3627,
    x2: 12.158,
    y2: 19.3627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212322",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDLogo);
export default __webpack_public_path__ + "static/media/d_logo.26559a613acdb84e332daf74182cc69c.svg";
export { ForwardRef as ReactComponent };